import { SelectOption, ToastData } from "@/@types";
import { EventBus, EventBusNames } from "@/utils/EventBus";

export const formatCurrency = (value: Number): string => {
  if (!value) return "R$ 0,00";
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

export const formatPhone = (value: string): string => {
  if (!value) return "";

  const searchValue = /(\d{2})(\d{5})(\d{0,4})/;
  const replaceValue = "($1) $2-$3";

  // Remove qualquer caractere que não seja número
  const numericValue = value.replace(/\D/g, "");

  // Limita ao tamanho máximo permitido (11 dígitos)
  const maxDigits = 11;
  const limitedValue = numericValue.substring(0, maxDigits);

  return limitedValue.replace(searchValue, replaceValue).trim();
};

export const formatCPF = (value: string): string => {
  const numericValueCPF = value.replace(/\D/g, "");
  // Remove caracteres excedentes (CPF só tem 11 dígitos)
  const limitedValueCPF = numericValueCPF.substring(0, 11);
  // Aplica a máscara enquanto digita

  return limitedValueCPF
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4")
    .trim();
};

export const showToast = (data: ToastData) => {
  EventBus.$emit(EventBusNames.SHOW_TOAST, data);
  const button = document.getElementById("notification_toast_button");
  if (button) button?.click();
};

export const dataURLtoFile = (dataurl: string, filename: string): File => {
  let arr = dataurl.split(",");
  let type;
  let mime: any = arr[0].match(/:(.*?);/);
  type = mime[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type });
};

export const getAddressFromCep = async (cep: string) => {
  return fetch(`https://viacep.com.br/ws/${cep}/json`).then((r) => r.json());
};

export const currencyToNumber = (value: string): number => {
  return Number(value.replace("R$", "").replace(",", "."));
};

export const removeEmptyValues = (obj: { [key: string]: string }) => {
  const novoObj: { [key: string]: string } = {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key) && obj[key] !== "") {
      novoObj[key] = obj[key];
    }
  }

  return novoObj;
};

export const mapToSelectOptions = <T>(data: T[], properties: { propertyForLabel: keyof T, propertyForValue: keyof T }): SelectOption[] => {
  if (!data) return []
  try {
    const options = data.map(element => {
      return {
        label: element[properties.propertyForLabel] as string,
        value: element[properties.propertyForValue] as string
      }
    })
    return options
  } catch (error) {
    return []
  }
};
